import { useEffect, useState } from 'react';
import { api } from '../api.js';
import type { RuntimeMetric, RuntimeSummary } from '../api.js';
import { t } from '../i18n.js';

export function RuntimeSummaryTile() {
  const [data, setData] = useState<RuntimeSummary | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    void api.getRuntimeSummary()
      .then(setData)
      .catch((e: Error) => setErr(e.message));
  }, []);

  if (err) return <div className="runtime-tile is-error">{err}</div>;
  if (!data) return <div className="runtime-tile is-loading">…</div>;

  return (
    <div className="runtime-tile">
      <div className="runtime-tile-title">{t('runtimes.tile_title')}</div>
      <div className="runtime-tile-row">
        <Bucket label={t('runtimes.col_week')} m={data.week} />
        <Bucket label={t('runtimes.col_month')} m={data.month} />
        <Bucket label={t('runtimes.col_year')} m={data.year} />
      </div>
      {data.power_kw === null && (
        <div className="runtime-tile-hint">{t('runtimes.no_config_hint')}</div>
      )}
    </div>
  );
}

function Bucket({ label, m }: { label: string; m: RuntimeMetric }) {
  return (
    <div className="runtime-bucket">
      <div className="runtime-bucket-label">{label}</div>
      <div className="runtime-bucket-hours">{t('runtimes.hours', { n: m.hours.toFixed(m.hours < 10 ? 1 : 0) })}</div>
      {m.kwh !== null && (
        <div className="runtime-bucket-sub">{m.kwh.toFixed(0)} kWh</div>
      )}
      {m.eur !== null && (
        <div className="runtime-bucket-sub">{m.eur.toFixed(2)} €</div>
      )}
    </div>
  );
}
